import { createSelector } from 'reselect';

const selectPaymentTransactions = (state: any) => state.paymentTransactions;

export const selectPaymentTransactionsCurrentItem = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.current);

export const selectPaymentTransactionsListItems = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.list);

export const selectPaymentTransactionsItemById = (itemId: any) =>
    createSelector(selectPaymentTransactionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPaymentTransactionsQueryItems = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.query);

export const selectPaymentTransactionsCreatedItem = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.create);

export const selectPaymentTransactionsUpdatedItem = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.update);

export const selectPaymentTransactionsReadItem = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.read);

export const selectPaymentTransactionsDeletedItem = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.delete);

export const selectPaymentTransactionsSearchedItems = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.search);

export const selectPaymentTransactionsItemsCount = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.count);

export const selectPaymentTransactionsItemsFilter = createSelector([selectPaymentTransactions], (paymentTransactions) => paymentTransactions.filter);